import { AnyAction } from 'redux';
import {
  QUICK_SEARCH_QUERY,
  QUICK_SEARCH_RECEIVE,
  QUICK_SEARCH_SHOW_FULL_FORM,
  QUICK_SEARCH_SELECT_ITEM,
  QUICK_SEARCH_ACTIVE_TAB,
  QUICK_SEARCH_INPUT_ACTIVE,
} from '../constants';
import { QuickSearchResultItem } from '../Types/QuickSearchResultItem';

interface QuickSearchState {
  query: string;
  result?: { searchResult: QuickSearchResultItem, brandSearchUrl?: string; };
  showResult: boolean;
  showFullForm: boolean;
  selectedItem: number;
  inputActive: boolean;  
}

const DEFAULT_STATE: QuickSearchState = {
  query: '',
  showResult: false,
  showFullForm: false,
  selectedItem: -1,
  inputActive: false,
};

export const quickSearch = (
  state = DEFAULT_STATE,
  action: AnyAction
): QuickSearchState => {
  switch (action.type) {
    case QUICK_SEARCH_QUERY:
    case QUICK_SEARCH_RECEIVE:
    case QUICK_SEARCH_SHOW_FULL_FORM:
    case QUICK_SEARCH_SELECT_ITEM:
    case QUICK_SEARCH_ACTIVE_TAB:
    case QUICK_SEARCH_INPUT_ACTIVE:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
